import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import ChannelEngineForm from './ChannelEngineForm';

const AmazonForm = () => {
	const { t } = useTranslation();
	const {
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();

	const isLoading = isSubmitting || isFormLoading;
	return (
		<ChannelEngineForm>
			<FormItem label="tenantId" isLoading={isLoading}>
				<StringInput name="username" placeholder={t('fieldPlaceholder', { name: t(`tenantId`) })} />
			</FormItem>
		</ChannelEngineForm>
	);
};

export default AmazonForm;
